import { render } from "./TheSidebar.vue?vue&type=template&id=4d65ce08&scoped=true"
import script from "./TheSidebar.vue?vue&type=script&lang=js"
export * from "./TheSidebar.vue?vue&type=script&lang=js"

import "./TheSidebar.vue?vue&type=style&index=0&id=4d65ce08&scoped=true&lang=scss"
import "./TheSidebar.vue?vue&type=style&index=1&id=4d65ce08&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d65ce08"]])

export default __exports__